<template>
  <div class="flex-container">
    <div v-show="!isShowBulkDealManagement"  class="main-area">
      <div class="title">
        Ürün Komisyon Teklifleri
      </div>
      <div class="filter-area-bottom">
        <ProductDealFilters
          ref="filterComponentRef"
          @filter-emitter="changeFilterPayload"
        />
      </div>
      <div class="list-area box">
        <TableForDeal
          :data="data"
          :columns="columns"
          :is-loading="isLoading"
          :page-count="pageCount"
          :pagination="getPaginationForTable()"
          @onPageChanged="changePaginationPayload"
          @go-bulk-deal-management="isShowBulkDealManagement = true"
          @onFilterChanged="changeFilterPayload"
        />
      </div>
    </div>
    <BulkDealManagement
      v-show="isShowBulkDealManagement"
      @go-deal-main-page="isShowBulkDealManagement = false"
      :start-date="payload.startDate"
      :finish-date="payload.finishDate"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import ProductDealFilters from './partials/ProductDealFilters';
import TableForDeal from './partials/TableForDeal';
import { columns, getTableDataAsync } from './services/productDealService';
import BulkDealManagement from './BulkDealManagement/BulkDealManagement.vue';

const defaultPayload = {
  startDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' '),
  finishDate: '2099-01-04 23:59:59',
  productName: '',
  productCode: '',
  stockCode: '',
  gtin: '',
  status: null,
  searchCategoryIds: [],
  isCustomDeal: null,
  page: 0,
  pageSize: 10,
};

const store = useStore();
const isLoading = ref(true);
const data = ref([]);
const pageCount = ref(0);
const payload = ref({ ...defaultPayload });
const isShowBulkDealManagement = ref(false);

// Reset responsive features until the responsive design is ready.
const resetResponsive = () => {
  document.getElementById('app').style.minWidth = '1320px';
  document.querySelector('#app .topMenu').style.cssText =
    'display:flex !important';
  document.querySelector('#app .navbar').style.cssText =
    'display:block !important;margin-top:unset;';
};

const sendRequestAsync = async () => {
  isLoading.value = true;
  try {
    const response = await getTableDataAsync(payload.value);
    if (response.error) return;
    data.value = response.data;
    pageCount.value = response.pageCount;
  } catch (error) {
    throw error;
  } finally {
    isLoading.value = false;
  }
};

const changeFilterPayload = (newFiltersPayload) => {
  if(!newFiltersPayload.hasOwnProperty("gtin")) {
    delete payload.value.isCustomDeal;
  }

  payload.value = {
    ...payload.value,
    ...newFiltersPayload,
    page: 0,
  };
};

const changePaginationPayload = (pagination) => {
  const { page, pageSize } = payload.value;
  if (page === pagination.page && pageSize === pagination.pageSize && !pagination.refreshKey) return;
  payload.value = {
    ...payload.value,
    ...pagination,
  };
};

const getPaginationForTable = () => {
  return {
    page: payload.value.page,
    pageSize: payload.value.pageSize,
  };
};

onMounted(async () => {
  resetResponsive();
  sendRequestAsync();
  store.dispatch('common/clearCustomDealNotification');
});

watch(payload, () => sendRequestAsync());
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';
@import '@/assets/styles/utilities';

.flex-container {
  display: flex;
  width: 100%;

  .main-area {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
  }

  .title {
    padding: 16px 0;
    color: $colorN80;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 26px;
  }

  .filter-area-bottom {
    width: 100%;
    padding: 24px;
    margin-bottom: 16px;
    background: $colorN00;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .list-area {
    border-radius: 8px;

    &.box {
      width: 100%;
      padding: 24px;
      background: $colorN00;
    }
  }
}
</style>
